export const DES_SEARCH_INPUT_THRESHOLD = 10;
